import Notifications from '../components/notifications';
import React from 'react';
import Constants from '../const';
import Navbar from '../components/navbar.jsx';
import { selectContentId } from '../selectors/route_params';
import connect from '../components/connect';
import classnames from 'classnames';
import { swEnabled } from '../engage_cache';
import AuralNotification from 'components/aural_notification';
import SkipLink from 'components/skip_link';

/*eslint no-var: [2] */
import PropTypes from 'prop-types';

class App extends React.Component {
    static propTypes = {
        children: PropTypes.object.isRequired,
        routes: PropTypes.array.isRequired,
        params: PropTypes.object.isRequired,
    };

    renderNavbar = () => {
        const contentId = selectContentId(this.props.params);

        return (
            <Navbar
                params={this.props.params}
                title={Constants.NAVBAR.TITLE}
                contentId={contentId}
            />
        );
    };

    render() {
        const classes = classnames('app-wrapper', {
            'sw-enabled': swEnabled,
        });

        return (
            <div className={classes}>
                <AuralNotification />
                <SkipLink />
                <div role="banner">{this.renderNavbar()}</div>
                <div className="main" role="main">
                    {this.props.children}
                </div>
                <Notifications />
            </div>
        );
    }
}

export default connect()(App);



// WEBPACK FOOTER //
// ./src/controllerviews/app.jsx